module.exports = __webpack_public_path__ + "img/img_tree.5b4624cd.png";